export default __webpack_public_path__ + "static/media/code-of-conduct.3df3ab42.jpeg";